import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  SAMPLE_INFO_MSG,
  SAMPLE_SIZE_RESTRICTION_WARNING,
  DEFAULT_SEGMENT_MESSAGE_SEGMENT_POPUP,
} from '../../../messages/messages';
import GenericButton from '../../common/GenericButton';
import { numberWithCommas } from '../../../util/CommonUtils';
import { SAMPLE_SIZE_RESTRICTION } from '../../../constants';

class PersonaCreatorMultiSegments extends Component {
  constructor(props) {
    super(props);
    let firstThreeSelectedSegments = [];

    if (
      this.props.originalSegmentsData.segments !== undefined &&
      this.props.originalSegmentsData.segments.length === 3
    ) {
      firstThreeSelectedSegments = _.filter(
        this.props.originalSegmentsData.segments,
        segment => (parseInt(segment.sample, 0) >= SAMPLE_SIZE_RESTRICTION)
      );
    }

    this.state = {
      segmentsData: {
        defId: '',
        defName: '',
        variance: '',
        segments: firstThreeSelectedSegments,
      },
    };

    this.onCheckBoxCLicked = this._onCheckBoxCLicked.bind(this);
    this.showSegmentRestrictionMsg = this._showSegmentRestrictionMsg.bind(this);
    this.closeSegmentScreen = this._closeSegmentScreen.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((nextProps.multiClusterSegmentsData && !_.isEmpty(nextProps.multiClusterSegmentsData))
    && (nextProps.multiClusterSegmentsData.segments &&
      !_.isEmpty(nextProps.multiClusterSegmentsData.segments))) {
      if (
        (this.props.multiClusterSegmentsData.segments.length !==
        nextProps.multiClusterSegmentsData.segments.length) ||
        (this.props.selectedExpressionObject.length !==
          nextProps.selectedExpressionObject.length)
      ) {
        const segmentsData = {
          defId: '',
          defName: '',
          variance: '',
          segments: [],
        };
        this.setState({
          segmentsData,
        });
      }
    }
  }

  _onCheckBoxCLicked(evt) {
    const copyOfSelecetdSegmants = _.clone(this.state.segmentsData.segments);
    const findIndex = this.state.segmentsData.segments.findIndex(
      obj => obj.id === parseInt(evt.target.value, 0),
    );
    if (findIndex === -1) {
      copyOfSelecetdSegmants.push(
        this.props.multiClusterSegmentsData.segments.find(
          segment => segment.id === parseInt(evt.target.value, 0),
        ),
      );
    } else {
      copyOfSelecetdSegmants.splice(findIndex, 1);
    }
    const segmentsData = { ...this.state.segmentsData,
      defId: this.props.multiClusterSegmentsData.defId,
      defName: this.props.multiClusterSegmentsData.defName,
      variance: this.props.multiClusterSegmentsData.variance,
      segments: copyOfSelecetdSegmants,
    };
    this.setState({
      segmentsData,
    });
  }

  _showSegmentRestrictionMsg() {
    const filterSegmentData = _.filter(
      this.props.multiClusterSegmentsData.segments,
      segment => (parseInt(segment.sample, 0) >= SAMPLE_SIZE_RESTRICTION),
    );

    return parseInt(filterSegmentData.length, 0) <= 3;
  }

  compareSegments = () => {
    const segmentsData = _.clone(this.state.segmentsData);
    if (segmentsData.variance === '') {
      segmentsData.variance = this.props.multiClusterSegmentsData.variance;
    }
    segmentsData.segments.sort((a, b) => a.id - b.id);

    this.setState({ segmentsData }, () => {
      this.props.updateSegmentsData(this.state.segmentsData);
    });
  };

  _closeSegmentScreen() {
    this.props.disableSegmentScreen();
  }

  render() {
    const { multiClusterSegmentsData } = this.props;
    return (
      <div className="container persona-multi-segments-layout">
        <div className="row">
          <div
            className="large-12 medium-12 small-12 columns"
            style={{ marginTop: '2%' }}
          >
            {!this.showSegmentRestrictionMsg() && (
              <span style={{ color: 'darkred' }}>
                {' '}
                {DEFAULT_SEGMENT_MESSAGE_SEGMENT_POPUP} :
              </span>
            )}
            {this.showSegmentRestrictionMsg() && (
              <span style={{ color: 'darkred', float: 'left' }}>
                {' '}
                {SAMPLE_SIZE_RESTRICTION_WARNING}
              </span>
            )}
            <br />
            <br />
          </div>
          <div className="row">
            <div className="columns large-offset-6 medium-offset-6 small-offset-6 large-6 medium-6 small-6">
              <div className="large-4 medium-4 small-4 columns">
                <span style={{ color: 'darkred', marginLeft: '-6%' }}>
                  {' '}
                  Sample Size{' '}
                </span>
                <span className="segmentInfo-text" title={SAMPLE_INFO_MSG} />
              </div>
              <div className="large-4 medium-4 small-4 columns">
                <span style={{ color: 'darkred', marginLeft: '-3%' }}>
                  {' '}
                  Weighted{' '}
                </span>
                <span className="segmentInfo-text" title={WEIGHTED_INFO_MSG} />
              </div>
              <div className="columns large-4 medium-4 small-4">
                <span style={{ color: 'darkred' }}>Segment Reach </span>
                <span className="segmentInfo-text" title={REACH_INFO_MSG} />
              </div>
            </div>
          </div>
          {multiClusterSegmentsData !== undefined &&
            multiClusterSegmentsData.segments !== undefined &&
            multiClusterSegmentsData.segments.length > 0 &&
            multiClusterSegmentsData.segments.map((segment, index) => {
              const checked =
                _.findIndex(this.state.segmentsData.segments, {
                  id: segment.id,
                }) > -1
                  ? 'checked'
                  : '';
              return (
                <div className="row" style={{ marginBottom: '1%' }} key={index}>
                  <div className="large-6 medium-6 small-6 columns">
                    <div className="large-1 medium-1 small-1 columns">
                      <input
                        className="persona-multi-segments-checkbox"
                        type="checkbox"
                        name={`${segment.title}`}
                        value={`${segment.id}`}
                        checked={`${checked}`}
                        disabled={
                          parseInt(segment.sample, 0) < SAMPLE_SIZE_RESTRICTION
                        }
                        onChange={e => this.onCheckBoxCLicked(e)}
                      />
                    </div>
                    <div
                      style={{ backgroundColor: 'black' }}
                      className="large-11 medium-11 small-11 columns"
                    >
                      <p style={{ color: 'white' }}> {segment.title} </p>
                    </div>
                  </div>
                  <div
                    style={{ backgroundColor: 'black', height: '35px' }}
                    className="large-6 medium-6 small-6 columns"
                  >
                    <div className="row">
                      <div className="large-4 medium-4 small-4 columns">
                        <span style={{ color: 'white', fontSize: 20 }}>
                          {numberWithCommas(segment.sample)}
                        </span>
                      </div>
                      <div className="large-4 medium-4 small-4 columns">
                        <span style={{ color: 'white', fontSize: 20 }}>
                          {numberWithCommas(segment.weighted)}
                        </span>
                      </div>
                      <div className="columns large-4 medium-4 small-4">
                        <span style={{ color: 'white', fontSize: 20 }}>
                          {Math.round(segment.pct * 1000) / 10}%{' '}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          <div className="row">
            <div className="columns large-offset-8 medium-offset-8 small-offset-8 large-2 medium-2 small-2">
              {this.state.segmentsData.segments.length === 3 && (
                <GenericButton
                  type="button"
                  name="Compare"
                  btnStyle="persona-multi-segments-button-active"
                  onBtnClick={() => this.compareSegments()}
                />
              )}
              {this.state.segmentsData.segments.length !== 3 && (
                <GenericButton
                  type="button"
                  name="Compare"
                  btnStyle="persona-multi-segments-button-inactive"
                  btnDisabled
                />
              )}
            </div>
            <div className="columns large-2 medium-2 small-2">
              <GenericButton
                type="button"
                name="Cancel"
                btnStyle="persona-multi-segments-cancel-button-active"
                onBtnClick={() => this.closeSegmentScreen()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PersonaCreatorMultiSegments.propTypes = {
  multiClusterSegmentsData: PropTypes.shape({}).isRequired,
  originalSegmentsData: PropTypes.shape({}).isRequired,
  updateSegmentsData: PropTypes.func,
  selectedExpressionObject: PropTypes.arrayOf(PropTypes.shape({})),
};
export default PersonaCreatorMultiSegments;
